import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  loadingWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0.5,
    zIndex: 1,
    '& img': {
      width: 42
    }
  },
  errorWrapper: {
    width: '100%',
    height: '100%',
    // position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    alignItems: 'center',
    backgroundColor: 'transparent'
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 14,
    padding: '28px 24px',
    borderRadius: 14,
    backgroundColor: theme.palette.background.primary.main,
    maxWidth: 760,
    minWidth: 460,
    width: 'fit-content',
    boxSizing: 'border-box'
  },

  errorIconSpot: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 8
  },

  errorIconOuterCircle: {
    width: 54,
    height: 54,
    borderRadius: '50%',
    backgroundColor: theme.palette.secondary.main,
    opacity: 0.85,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },

  errorIconContainer: {
    width: 42,
    height: 42,
    borderRadius: '50%',
    backgroundColor: theme.palette.text.secondary,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${theme.palette.secondary.main}`
  },

  errorIcon: {
    color: theme.palette.primary.main,
    fontSize: 42
  },

  errorTextContainer: {
    maxWidth: 450,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    width: '100%',
    textAlign: 'center'
  },

  errorTitle: {
    color: theme.palette.primary.main,
    fontFamily: theme.app.typography.fontFamily.main,
    fontSize: 20,
    fontWeight: 700,
    lineHeight: '28px'
  },

  errorMessage: {
    color: theme.palette.primary.main,
    fontFamily: theme.app.typography.fontFamily.secondary,
    fontSize: 14,
    fontWeight: theme.app.typography.paragraph.fontWeight,
    lineHeight: '20px'
  },

  buttonIcon: {
    fontSize: 16,
    marginRight: 8
  },

  retryButton: {
    width: 'fit-content',
    marginTop: 16
  },

  '@media (max-width: 960px)': {
    errorContainer: {
      minWidth: 'unset',
      width: '100%',
      padding: '24px 18px'
    },
    errorTitle: {
      fontSize: 18,
      lineHeight: '24px'
    },
    errorMessage: {
      fontSize: 13,
      lineHeight: '18px'
    }
  }
}))
